import { render, staticRenderFns } from "./p02.vue?vue&type=template&id=5a95d89a&scoped=true&"
import script from "./p02.vue?vue&type=script&lang=js&"
export * from "./p02.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a95d89a",
  null
  
)

export default component.exports